// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Clientes_EnviarNotificacaoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /clientes/enviar-notificacao
 *
 * What the portal accepted. The portal answers 202 once the INBOX ROW is
 * durably stored, and only then attempts Web Push asynchronously — so a
 * successful response here means "the customer will see this when they open the
 * app", NOT "a notification reached their phone".
 *
 * The staff SPA must say it that way. `push_targets: 0` with a successful send
 * is the common case, not a failure: it means the customer has no device
 * subscribed yet, and the message is waiting in their inbox regardless.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Clientes_EnviarNotificacaoResponseDados {
cliente_id: number
notification_id?: string
state?: string
created_at?: string
push_targets?: number
warning?: string
}

export type Clientes_EnviarNotificacaoResponse = ApiResponse<Clientes_EnviarNotificacaoResponseDados>;

registerResponseContract('Clientes_EnviarNotificacaoResponse', {
  cliente_id:      { type: 'number',  required: true },
  notification_id: { type: 'string',  required: false },
  state:           { type: 'string',  required: false },
  created_at:      { type: 'string',  required: false },
  push_targets:    { type: 'number',  required: false },
  warning:         { type: 'string',  required: false },
})
